import { render, staticRenderFns } from "./BaseInfoChange.vue?vue&type=template&id=5b9b2907&scoped=true&"
import script from "./BaseInfoChange.vue?vue&type=script&lang=js&"
export * from "./BaseInfoChange.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfoChange.vue?vue&type=style&index=0&id=5b9b2907&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b2907",
  null
  
)

export default component.exports